import { useTranslation } from "react-i18next";
import BoldText from "~/src/components/Text/BoldText";
import getAppInfo from "~/src/helpers/getAppInfo";

function Om(): JSX.Element {
  const { t } = useTranslation();
  const appInfo = getAppInfo();
  return (
    <div className="m-4 text-ldir-brown-900 bg-banner2 h-[calc(100vh-100px)] min-h-fit bg-cover bg-bottom flex flex-col justify-between">
      <div className="text-lg">
        <h2 className="font-serif text-2xl font-bold mb-6">{t("pages.omSos.subtitle")}</h2>
        <BoldText className="text-xl" text={t("pages.omSos.jegerKan")} numBoldWords={100} />
        <BoldText className="mt-2" text={t("pages.omSos.registreringene")} numBoldWords={4} />
        <BoldText className="mt-2" text={t("pages.omSos.forElgOgHjort")} numBoldWords={4} />
        <BoldText className="mt-2" text={t("pages.omSos.forRadyrOgVillrein")} numBoldWords={4} />
        <BoldText text={t("pages.omSos.radyrOgVillrein")} numBoldWords={3} />
      </div>
      <div className="text-center text-ldir-blue-900 mt-6">
        <p>VERSJON</p>
        <p>{appInfo.version}</p>
      </div>
    </div>
  );
}

export default Om;
